import { fetchApiUrl } from 'entities/app'
import { persistStore } from 'redux-persist'

import store, { dispatch } from './store'

const persistor = persistStore(store, undefined, () => dispatch(fetchApiUrl(true)))

export default persistor
